import React from 'react';


function DlgRelGraficoResTurno() {
  return (
    <>
      <iframe width="100%" height="100%" style={{ border:'none' }} src="https://bi.unidatanet.com.br/VLI/#/pages/itemFrmTurnoResumoAderencia?url="></iframe>
    </>
  );
}


export default DlgRelGraficoResTurno;
